export enum CampaignDepartment {
  FB,
  GOOGLE,
  TIKTOK,
  OTHER,
  PPC,
  ORGANIC,
  ASO,
}
